import { Box, Step, Stepper, useMediaQuery, useTheme } from '@mui/material'
import { CustomizedConnector, StepLabelStyled } from 'src/forms/DeviationStepperForm/DeviationStepperForm.style'

interface FormStepperProps {
  steps: [{ label: string; completed: boolean; active: boolean }]
}
const FormStepper: React.FC<FormStepperProps> = ({ steps }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery<any>(theme.breakpoints.down('sm'))

  return (
    <Box
      key="stepper-header"
      sx={{
        width: '100%',
        paddingBottom: '12px',
        overflowX: isMobile ? 'auto' : 'visible',
      }}
    >
      <Stepper
        activeStep={steps.findIndex(step => step.active)}
        orientation={isMobile ? 'vertical' : 'horizontal'}
        sx={{
          paddingTop: 1,
          width: '100%',
          minWidth: isMobile ? 'unset' : '600px',
        }}
        connector={isMobile ? undefined : <CustomizedConnector />}
      >
        {steps.map((step, index) => {
          return (
            <Step key={index} completed={step.completed}>
              <StepLabelStyled>{step.label}</StepLabelStyled>
            </Step>
          )
        })}
      </Stepper>
    </Box>
  )
}

export default FormStepper
